module.exports = __webpack_public_path__ + "img/blue_105.9648a4e7.png";